export class ProjectReleatedProfilesTypeEnum {
    constructor() {
        this.NO_DEFINIDO = 0;
        this.OBLIGADO_SOLIDARIO = 1;
        this.CONTACTO_RELACIONADO = 2;
        this.REFERENCIA = 3;
    }

    toArray() {
        return {
            [this.NO_DEFINIDO]: "No definido",
            [this.OBLIGADO_SOLIDARIO]: "Obligado a solidario",
            [this.CONTACTO_RELACIONADO]: "Contacto Relacionado",
            [this.REFERENCIA]: "Referencia"
        }
    }
}